import { render, staticRenderFns } from "./PaymentMethodsSelect.vue?vue&type=template&id=6d8f2430&scoped=true"
import script from "./PaymentMethodsSelect.vue?vue&type=script&lang=js"
export * from "./PaymentMethodsSelect.vue?vue&type=script&lang=js"
import style0 from "./PaymentMethodsSelect.vue?vue&type=style&index=0&id=6d8f2430&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8f2430",
  null
  
)

export default component.exports